import React from 'react';
import { Grid, Typography, Box, Avatar } from '@mui/material';
import { themes, fonts } from '../../themes/themes';
import './UpcomingBirthdayBox.css';
import { DateField } from '../../../components';
import { baseDateFormatting } from '../../helper';

interface birthdayList {
  pic?: string;
  date?: string;
  name?: string;
  event_name?: string;
}

const UpcomingBirthdayBox = ({
  date,
  name,
  pic,
  event_name = 'Birthday',
}: birthdayList) => {
  return (
    <Grid container className="eventBox_birdthayy" spacing={1}>
      <Grid item xs={3}>
        <Box className="right__content">
          <Avatar
            src={pic}
            style={{
              width: '60px',
              height: '60px',
              borderRadius: '4px',
            }}
          />
        </Box>
      </Grid>
      <Grid
        item
        xs={9}
        style={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          height: '60px',
        }}
      >
        <Typography
          style={{
            fontFamily: fonts.fontFamily,
            fontSize: fonts.subtitle,
            color: themes.defaultSuccess,
          }}
        >
          {date ? <DateField value={date} format={baseDateFormatting} /> : null}
        </Typography>
        <Typography
          style={{
            fontFamily: fonts.fontFamily,
            fontSize: fonts.title,
            color: themes.darkBlue,
            fontWeight: 'bold',
          }}
        >
          {name}
        </Typography>
        <Typography
          style={{
            fontFamily: fonts.fontFamily,
            fontSize: fonts.subtitle,
            color: themes.greySubtitle,
          }}
        >
          {event_name}
        </Typography>
      </Grid>
    </Grid>
  );
};

export default UpcomingBirthdayBox;
